import React, { useContext, useEffect, useState } from 'react'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { Fragment } from 'react';
import { AuthContext } from '../../../App/App';
import { CSContext } from './CustomerServices';
import axios from 'axios';
import qs from 'querystring';
import swal from 'sweetalert';

function ModalAddEditCustomerServices() {
    const { stateAuth, dispatchAuth } = useContext(AuthContext);
    const { stateCS, dispatchCS } = useContext(CSContext);


    const initalDataForm = {
        email: '',
        errEmail: null,
        username: '',
        errUsername: null,
        displayname: '',
        errDisplayName: null,
        password: '',
        errPassword: null,
        employeeID: null,
    }
    const [dataForm, setdataForm] = useState(initalDataForm)
    const [dataFormRole, setdataFormRole] = useState({ role: '', err: null })
    const [emailOption, setEmailOption] = useState({ suggest: false, emails: [], edited: false, was_change: false, chekSSO: null })
    const [roleOption, setroleOption] = useState({ roles: [] })

    const handleCencelClick = () => {
        setdataForm(initalDataForm)
        setdataFormRole({ role: '', err: null })
        setEmailOption({ suggest: false, emails: [], edited: false, was_change: false, chekSSO: null })
        dispatchCS({
            type: "MODAL_ADD_EDIT",
            modalAddEdit: {
                status: false,
                action: null
            }
        })
    }

    const handleEditPassword = () => {
        setdataForm({
            ...dataForm,
            password: '',
            errPassword: null
        })
        setEmailOption({
            ...emailOption,
            edited: !emailOption.edited
        })

    }

    const handleSubmitClick = () => {
        //check null
        if ((dataForm.email != '' && dataForm.username != '' && dataForm.displayname != '' && dataFormRole.role != '') && (stateCS.modalAddEdit.action == "add" ? ((emailOption.suggest == false && dataForm.password != '') || (emailOption.suggest == true)) : ((emailOption.was_change && !emailOption.suggest) ? dataForm.password != '' : emailOption.edited ? dataForm.password != '' : dataForm.password == ''))) {
            //check format
            const pattern = /[a-zA-Z0-9]+[\.]?([a-zA-Z0-9]+)?[\@][a-z]{2,9}[\.][a-z]{2,5}/g;
            const testEmail = pattern.test(dataForm.email);
            if (testEmail == true) {
                if (stateCS.modalAddEdit.action == 'add') createCS()
                else if (stateCS.modalAddEdit.action == 'edit') editCS()
            } else {
                setdataForm({
                    ...dataForm,
                    errEmail: 'Invalid email address.',
                    errDisplayName: null,
                    errPassword: null,
                    errUsername: null
                })

                setdataFormRole({
                    ...dataFormRole,
                    err: null
                })
            }
        } else {
            setdataForm({
                ...dataForm,
                errEmail: dataForm.email == '' ? 'Please enter email address.' : null,
                errDisplayName: dataForm.displayname == '' ? 'Please enter display name.' : null,
                errPassword: emailOption.suggest == true ? null : dataForm.password == '' ? 'Please enter password.' : null,
                errUsername: dataForm.username == '' ? 'Please enter username.' : null
            })
            setdataFormRole({
                ...dataFormRole,
                err: dataFormRole.role == '' ? 'Please choosee user role.' : null
            })
        }
    }

    const handleInputChange = (event) => {
        const value = event.target.value
        const name = event.target.name
        if (name == "email") {
            const pattern = /[a-zA-Z0-9]+[\.]?([a-zA-Z0-9]+)?[\@][a-z]{2,9}[\.][a-z]{2,5}/g;
            const findEmail = emailOption.emails.find(data => data.email == value);
            if (findEmail == undefined) {
                setdataForm({
                    ...dataForm,
                    email: value,
                    errEmail: value === '' ? 'Please enter email address.' : (!pattern.test(dataForm.email)) ? 'Invalid email address.' : null,
                    employeeID: null,
                })
            } else if (findEmail) {
                setdataForm({
                    ...dataForm,
                    email: value,
                    errEmail: value === '' ? 'Please enter email address.' : null,
                    employeeID: findEmail.employee_id,
                    displayname: stateCS.modalAddEdit.action == 'add' ? findEmail.name : dataForm.displayname,
                    errDisplayName: null,
                    password: '',
                    errPassword: null
                })
            }
            setEmailOption({
                ...emailOption,
                suggest: findEmail !== undefined,
                was_change: stateCS.selected ? (stateCS.customerServices.find(data => data.id === stateCS.selected).email !== value) : false
            })
        } else {
            setdataForm({
                ...dataForm,
                [name]: value,
                errDisplayName: (name == 'displayname') ? (value === '') ? 'Please enter display name.' : null : dataForm.errDisplayName,
                errPassword: (name == 'password') ? (value === '') ? 'Please enter password.' : null : dataForm.errPassword,
                errUsername: (name == 'username') ? (value === '') ? 'Please enter username.' : null : dataForm.errUsername,
            })
        }
    }

    const handleInputRole = (event) => {
        setdataFormRole({
            role: event.target.value,
            err: (event.target.value == '' ? 'Please choosee user role.' : null)
        })
    }

    const getEmails = () => {
        const config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'x-access-token': localStorage.getItem('token-helpdesk-umy')
            }
        }
        axios.get(`/api/v1/helpdesk/setting/customer-services/employee`, config)
            .then(res => {
                setEmailOption({
                    ...emailOption,
                    emails: res.data.data
                })
            })
            .catch(err => {
                if (!err.response || err.code === 'ECONNABORTED') {
                    swal("Error!", "Check Your Internet Connection!", "error", {
                        button: "OK",
                    });
                } else if (err.response) {
                    if (err.response.data.status === 'jwt' && err.response.data.message === `TokenExpiredError`) {
                        dispatchAuth({
                            type: "LOGOUT",
                            message: 'Token expired, please login again!!!'
                        })
                    } else if (err.response.data.message) {
                        swal("Error!", `${JSON.stringify(err.response.data.message)}`, "error", {
                            button: "OK",
                        });
                    }
                }
            })
    }

    const getRoles = () => {
        const config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'x-access-token': localStorage.getItem('token-helpdesk-umy')
            }
        }
        axios.get(`/api/v1/helpdesk/setting/customer-services/roles`, config)
            .then(res => {
                setroleOption({
                    roles: res.data.data
                })
            })
            .catch(err => {
                if (!err.response || err.code === 'ECONNABORTED') {
                    swal("Error!", "Check Your Internet Connection!", "error", {
                        button: "OK",
                    });
                } else if (err.response) {
                    if (err.response.data.status === 'jwt' && err.response.data.message === `TokenExpiredError`) {
                        dispatchAuth({
                            type: "LOGOUT",
                            message: 'Token expired, please login again!!!'
                        })
                    } else if (err.response.data.message) {
                        swal("Error!", `${JSON.stringify(err.response.data.message)}`, "error", {
                            button: "OK",
                        });
                    }
                }
            })
    }

    const createCS = () => {
        const reqBody = {
            username: dataForm.username,
            email: dataForm.email,
            display_name: dataForm.displayname,
            password: dataForm.password,
            role_id: dataFormRole.role,
            employee_id: dataForm.employeeID,
        }
        const config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'x-access-token': localStorage.getItem('token-helpdesk-umy')
            }
        }

        axios.post('/api/v1/helpdesk/setting/customer-services/customer-service', qs.stringify(reqBody), config)
            .then(res => {
                dispatchCS({
                    type: "INSERTED",
                    customerService: { id: res.data.data.center, username: dataForm.username, displayname: dataForm.displayname, email: dataForm.email, role: { id: dataFormRole.role, name: roleOption.roles.find(r => r.role_id == dataFormRole.role).role_name } }
                })

                handleCencelClick()

                swal("Success!", `${res.data.message}`, "success", {
                    button: "OK",
                });

                setdataForm({
                    ...dataForm,
                    errEmail: null,
                    errDisplayName: null,
                    errPassword: null,
                    errUsername: null
                })

                setEmailOption({ suggest: false, emails: [], edited: false })
            })
            .catch(err => {
                if (!err.response || err.code === 'ECONNABORTED') {
                    swal("Error!", "Check Your Internet Connection!", "error", {
                        button: "OK",
                    });
                } else if (err.response) {
                    if (err.response.data.status === 'jwt' && err.response.data.message === `TokenExpiredError`) {
                        dispatchAuth({
                            type: "LOGOUT",
                            message: 'Token expired, please login again...'
                        })
                    } else if (err.response.data.status === 'invalid') {
                        let username = null
                        let display_name = null
                        let role_id = null
                        let email = null
                        let pass = null
                        err.response.data.errors.map(err => {
                            username = (err.param === 'username') ? err.msg : username
                            display_name = (err.param === 'display_name') ? err.msg : display_name
                            role_id = (err.param === 'role_id') ? err.msg : role_id
                            email = (err.param === 'email') ? err.msg : email
                            pass = (err.param === 'password') ? err.msg : pass
                        })
                        setdataForm({
                            ...dataForm,
                            errDisplayName: display_name,
                            errEmail: email,
                            errPassword: pass,
                            errUsername: username
                        })

                        setdataFormRole({
                            ...dataFormRole,
                            err: role_id
                        })
                    } else {
                        swal("Error!", `${err.response.data.message}`, "error", {
                            button: "OK",
                        });
                    }
                }
            })
    }

    const editCS = () => {
        const config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'x-access-token': localStorage.getItem('token-helpdesk-umy')
            }
        }
        const reqBody = {
            username: dataForm.username,
            email: dataForm.email,
            old_email: stateCS.customerServices.find(data => data.id == stateCS.selected).email,
            display_name: dataForm.displayname,
            role_id: dataFormRole.role,
            employee_id: dataForm.employeeID,
            password: dataForm.password,
            sso: emailOption.suggest
        }
        axios.put(`/api/v1/helpdesk/setting/customer-services/customer-service/${stateCS.selected}`, qs.stringify(reqBody), config)
            .then(res => {
                const data = {
                    id: stateCS.selected,
                    username: dataForm.username,
                    displayname: dataForm.displayname,
                    email: dataForm.email,
                    role: {
                        id: dataFormRole.role,
                        name: roleOption.roles.find(role => role.role_id == dataFormRole.role).role_name
                    }
                }
                dispatchCS({
                    type: "TRIGGER",
                    trigger: "update-cs",
                    temp: data
                })
                handleCencelClick()

                swal("Success!", `${res.data.message}`, "success", {
                    button: "OK",
                });

                setdataForm({
                    ...dataForm,
                    errEmail: null,
                    errDisplayName: null,
                    errPassword: null,
                    errUsername: null
                })

                setEmailOption({ suggest: false, emails: [], edited: false, was_change: false })
            })
            .catch(err => {
                if (!err.response || err.code === 'ECONNABORTED') {
                    swal("Error!", "Check Your Internet Connection!", "error", {
                        button: "OK",
                    });
                } else if (err.response) {
                    if (err.response.data.status === 'jwt' && err.response.data.message === `TokenExpiredError`) {
                        dispatchAuth({
                            type: "LOGOUT",
                            message: 'Token expired, please login again...'
                        })
                    } else if (err.response.data.message == 'duplicate user') {
                        setdataForm({
                            ...dataForm,
                            errUsername: (err.response.data.data.username == 0) ? null : 'Username already registered!',
                        })
                    } else {
                        swal("Error!", `${err.response.data.message}`, "error", {
                            button: "OK",
                        });
                    }
                }
            })
    }

    const [renderModal, setRenderModal] = useState(<Fragment />)
    //setup option
    useEffect(() => {
        if (stateCS.modalAddEdit.status == true) {
            //get email
            getEmails()
            //get role
            getRoles()
        }
    }, [stateCS.modalAddEdit])

    const [renderEmail, setrenderEmail] = useState(<datalist id="userslist"></datalist>)
    useEffect(() => {
        if (emailOption.emails.length > 0) {
            setrenderEmail(
                <datalist id="userslist">
                    {emailOption.emails.map(email => (
                        <option key={email.employee_id} value={email.email} />
                    ))}
                </datalist>)
        }
    }, [emailOption.emails])

    useEffect(() => {
        //set init data
        if (stateCS.modalAddEdit.action == 'edit') {
            const profile = stateCS.customerServices.find(cs => cs.id == stateCS.selected);
            setdataForm({
                ...dataForm,
                email: profile.email,
                username: profile.username,
                displayname: profile.displayname,
                employeeID: profile.employee
            })

            setdataFormRole({
                ...dataFormRole,
                role: profile.role.id
            })

            setEmailOption({
                ...emailOption,
                suggest: emailOption.emails.find(email => email.email == profile.email) !== undefined,
                edited: false,
                chekSSO: emailOption.emails.find(email => email.email == profile.email) !== undefined,
            })
        } else {
            setdataForm(initalDataForm)
            setdataFormRole({ role: '', err: null })
        }
    }, [stateCS.modalAddEdit, emailOption.emails])

    useEffect(() => {
        if (stateCS.modalAddEdit.status == true) {
            setRenderModal(
                <Fragment>
                    <Modal className="modal-dialog modal-dialog-centered" isOpen={stateCS.modalAddEdit.status} backdrop={'static'} keyboard={true}>
                        <ModalHeader toggle={handleCencelClick} charCode={<i className="fas fa-times-circle" style={{ fontSize: '20px' }}></i>}>
                            {stateCS.modalAddEdit.action == "add" ? `Add New Admin` : `Edit Admin`}
                        </ModalHeader>
                        <ModalBody>
                            <div className="form-group row">
                                <label htmlFor="email" className="col-form-label">Email</label>
                                <div className="input-group  has-validation">
                                    <input type="email" list="userslist" className={`form-control ${dataForm.errEmail != null ? 'is-invalid' : ''}`} id="email" name="email" autoFocus value={dataForm.email} onChange={handleInputChange} placeholder="Email Address" aria-describedby="validationEmail" />
                                    {renderEmail}
                                    <div id="validationEmail" className="invalid-feedback">
                                        <small>{dataForm.errEmail}</small>
                                    </div>
                                </div>
                            </div>
                            <div className="form-group row">
                                <label htmlFor="displayname" className="col-form-label">Name</label>
                                <div className="input-group  has-validation">
                                    <input type="text" className={`form-control ${dataForm.errDisplayName != null ? 'is-invalid' : ''}`} id="displayname" name="displayname" value={dataForm.displayname} onChange={handleInputChange} placeholder="Display Name" aria-describedby="validationDisplayname" />
                                    <div id="validationDisplayname" className="invalid-feedback">
                                        <small>{dataForm.errDisplayName}</small>
                                    </div>
                                </div>
                            </div>
                            <div className="form-group row">
                                <label htmlFor="role" className="col-form-label">Role</label>
                                <div className="input-group  has-validation">
                                    <select value={dataFormRole.role} name="role" id="role" className={`form-control form-select  ${dataFormRole.err != null ? 'is-invalid' : ''}`} required aria-describedby="validationRole" onChange={handleInputRole} >
                                        <option key={null} value="">Choose Role</option>
                                        {roleOption.roles.length > 0 ?
                                            roleOption.roles.map(r => (
                                                <option key={r.role_id} value={r.role_id}>{r.role_name}</option>
                                            )) :
                                            <Fragment />}
                                    </select>
                                    <div id="validationRole" className="invalid-feedback">
                                        <small>{dataFormRole.err}</small>
                                    </div>
                                </div>
                            </div>
                            <div className="form-group row">
                                <label htmlFor="username" className="col-form-label">Username</label>
                                <div className="input-group  has-validation">
                                    <input type="text" className={`form-control ${dataForm.errUsername != null ? 'is-invalid' : ''}`} id="username" name="username" autoFocus value={dataForm.username} onChange={handleInputChange} placeholder="Username" aria-describedby="validationUsername" />
                                    <div id="validationUsername" className="invalid-feedback">
                                        <small>{dataForm.errUsername}</small>
                                    </div>
                                </div>
                            </div>

                            {emailOption.suggest ? (
                                <div className="form-group pl-3">
                                    <div className="form-check">
                                        <input className="form-check-input" disabled type="checkbox" id="password" defaultChecked />
                                        <label className="form-check-label" htmlFor="password">SSO Password </label>
                                    </div>
                                </div>
                            ) : (stateCS.modalAddEdit.action == 'add' || (emailOption.was_change && emailOption.chekSSO && emailOption.emails.find(data => data.email === dataForm.email) === undefined)) ? (
                                <div className="form-group row">
                                    <label htmlFor="password" className="col-form-label">Password</label>
                                    <div className="input-group  has-validation">
                                        <input type="password" className={`form-control ${dataForm.errPassword != null ? 'is-invalid' : ''}`} id="password" name="password" value={dataForm.password} onChange={handleInputChange} placeholder="Password" aria-describedby="validationPassword" />
                                        <div id="validationPassword" className="invalid-feedback">
                                            <small>{dataForm.errPassword}</small>
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <div className="form-group row">
                                    <label htmlFor="password" className="form-label">Password</label>
                                    <div className="input-group has-validation">
                                        <input type="password" className={`form-control ${dataForm.errPassword != null ? 'is-invalid' : ''}`} id="password" name="password" value={!emailOption.edited ? 'dummy_password' : dataForm.password} onChange={handleInputChange} placeholder="Password" aria-describedby="inputGroupPrepend3 validationPassword" disabled={emailOption.edited ? false : true} />
                                        <span className={`input-group-text`} style={{ textTransform: 'capitalize', boxShadow: 'none', cursor: 'pointer', color: '#fff', backgroundColor: emailOption.edited ? 'grey' : 'green' }} id="inputGroupPrepend3" onClick={handleEditPassword}>{emailOption.edited ? 'Cancel' : 'Edit'}</span>
                                        <div id="passwordFeedback" className="invalid-feedback">
                                            <small>{dataForm.errPassword}</small>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </ModalBody>
                        <ModalFooter>
                            <Button style={{ textTransform: 'capitalize' }} color="secondary" onClick={handleCencelClick}>Cancel</Button>
                            <Button style={{ textTransform: 'capitalize' }} color={stateCS.modalAddEdit.action == 'add' ? 'success' : 'primary'} onClick={handleSubmitClick}> {stateCS.modalAddEdit.action == "add" ? (<Fragment>Add Admin<i className="fas fa-user-plus"></i></Fragment>) : (<Fragment>Edit Admin <i className="fas fa-edit"></i></Fragment>)} </Button>
                        </ModalFooter>
                    </Modal>
                </Fragment>
            )
        } else {
            setRenderModal(<Fragment />)
        }
    }, [stateCS.modalAddEdit, renderEmail, dataFormRole, dataForm, emailOption])
    return (
        renderModal
    )
}

export default ModalAddEditCustomerServices
